// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__32jw8","log":"ModalInventoryLogs_log__3PGA1","date":"ModalInventoryLogs_date__vAuHH","userName":"ModalInventoryLogs_userName__36jB_"};